import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { Claims } from '@/_shared/constants/claims';
import { useDialog } from '@/_shared/hooks';
import { getSubscriptionCall } from '@/billing/state';
import type { DialogContactsPayload } from '@/core/components/DialogContacts/DialogContacts';

export const MaxLearningLicenses: FC = () => {
  // eslint-disable-next-line @altermaind/use-translations-scope
  const t = useTranslations('settings.tabs.plan.yourPlan');
  const { learningLicenses, learningLicensesMax } = getSubscriptionCall.hook();
  const { openDialog: openContacts } = useDialog<DialogContactsPayload>('contacts');

  if (learningLicensesMax === undefined || learningLicensesMax > learningLicenses) {
    return null;
  }

  return (
    <ClaimsComponent claimKey={Claims.BILLING_WRITE}>
      <AlertBadge
        containerProps={{ mt: 'l', borderRadius: 'm', padding: 'none' }}
        type='transparent'
        iconName='lightBulb'
        label={t('learningLimitExceededAlert', { max: learningLicensesMax })}
        showCta
        ctaLabel={t('learningLimitExceededCta')}
        ctaProps={{ variant: 'positive', py: 'xxs', height: 'auto' }}
        onClick={() => openContacts({})}
      />
    </ClaimsComponent>
  );
};
